(function () {
  if (window.__luxoClickToArmHoverZoom) return;
  window.__luxoClickToArmHoverZoom = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var slide = target.closest('.product-main-slide');
    if (!slide) return;

    var plusControl = target.closest('.js-photoswipe__zoom.product__photo-zoom');
    var image = target.closest('img.photoswipe__image');
    if (!image) {
      var imageLink = target.closest('a');
      if (imageLink) image = imageLink.querySelector('img.photoswipe__image');
    }
    if (!plusControl && (!image || !slide.contains(image))) return;

    image = image || slide.querySelector('img.photoswipe__image');
    if (slide.classList.contains('luxo-hover-zoom-armed')) {
      slide.classList.remove('luxo-hover-zoom-armed');
      delete slide.dataset.luxoZoomLevel;
      if (image) {
        image.style.removeProperty('--luxo-zoom-scale');
        image.style.removeProperty('--luxo-zoom-origin');
      }
    } else {
      slide.classList.add('luxo-hover-zoom-armed');
      if (!slide.dataset.luxoZoomLevel) slide.dataset.luxoZoomLevel = '1.6';
      if (image) image.style.setProperty('--luxo-zoom-scale', slide.dataset.luxoZoomLevel);
    }
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('pointermove', function (event) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var target = event.target;
    if (!target || !target.closest) return;
    var slide = target.closest('.product-main-slide.luxo-hover-zoom-armed');
    if (!slide) return;

    var image = slide.querySelector('img.photoswipe__image');
    var wrapper = image && image.closest('.image-wrap');
    if (!image || !wrapper) return;

    var rect = wrapper.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
    var y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
    image.style.setProperty('--luxo-zoom-origin', x + '% ' + y + '%');
  }, true);

  // On desktop, the wheel zooms an armed product image; when zoom is off, it scrolls the page.
  window.addEventListener('wheel', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var slide = target.closest('.product-main-slide');
    if (!slide) return;

    if (slide.classList.contains('luxo-hover-zoom-armed')) {
      if (event.cancelable) event.preventDefault();
      event.stopImmediatePropagation();
      var current = parseFloat(slide.dataset.luxoZoomLevel || '1.6');
      var direction = event.deltaY < 0 ? 1 : -1;
      var next = Math.max(1.1, Math.min(3.5, current + direction * 0.15));
      slide.dataset.luxoZoomLevel = String(next);
      var image = slide.querySelector('img.photoswipe__image');
      if (image) image.style.setProperty('--luxo-zoom-scale', String(next));
      return;
    }

    if (event.cancelable) event.preventDefault();
    event.stopImmediatePropagation();
    window.scrollBy(0, event.deltaY);
  }, { capture: true, passive: false });


})();